<template>
  <nav>
    <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />
    <v-row align="center" justify="center" :class="mobile() ? 'pa-3' : ''">
      <v-col :cols="mobile() ? '12' : '11'" md="4" class="pa-md-10">
        <v-card rounded="xxl" color="accent" class="white--text text-center mx-auto" max-width="600px"
          data-testid="people-card" :to="{ name: 'PeopleInActivity' }">
          <v-card-title class="justify-center text-h1 font-weight-bold py-15 no-break" data-testid="people-card-title">
            {{ peopleInActivity }}
          </v-card-title>
          <v-card-subtitle class="white--text text-h5 font-weight-bold mt-0">
            {{ $tc('people', peopleInActivity) }}
          </v-card-subtitle>
          <v-card-text class="white--text text-body-2 pb-6">
            {{ $tc('peopleInActivityNumberText', peopleInActivity) }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col :cols="mobile() ? '12' : '11'" md="4" class="pa-md-10">
        <v-card rounded="xxl" color="darktext" class="white--text text-center mx-auto" max-width="600px"
          data-testid="boosters-card" :to="{ name: 'BoostersInActivity' }">
          <v-card-title class="justify-center text-h1 font-weight-bold py-15 no-break" data-testid="boosters-card-title">
            {{ boostersInActivity }}
          </v-card-title>
          <v-card-subtitle class="white--text text-h5 font-weight-bold mt-0">
            {{ $tc('boostersInActivityNumberTitle', boostersInActivity) }}
          </v-card-subtitle>
          <v-card-text class="white--text text-body-2 pb-6">
            {{ $tc('boostersInActivityNumberText', boostersInActivity) }}
          </v-card-text>
        </v-card>
      </v-col>
      <v-col :cols="mobile() ? '12' : '11'" md="4" class="pa-md-10">
        <v-card rounded="xxl" color="accent" class="white--text text-center mx-auto" max-width="600px"
          data-testid="chart-card">
          <div v-if="!loadingData" class="pa-5">
            <apexcharts v-if="notStarted == 0 && started == 0 && finished == 0" type="donut"
              :options="emptyOptions" :series="emptySeries" class="mx-auto" height="300px"></apexcharts>
            <apexcharts v-else type="donut" :options="options" :series="series" class="mx-auto" height="300px">
            </apexcharts>
          </div>
          <div v-else class="pa-5 fill-height d-flex align-center justify-center" style="height:300px">
            <v-progress-circular size="125" indeterminate class="" color="grey" />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getPeopleInActivity, getBoostersInActivity, getActivityPagesTotalStats } from '../../api/activityApi';
import AlertMessages from '../../components/AlertMessages'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    AlertMessages,
    apexcharts: VueApexCharts,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      alertMsg: '',
      alertType: '',
      alertValue: false,
      activityId: this.$route.params.id,
      pageNumber: 1,
      size: 1,
      loadingData: false,
      peopleInActivity: 0,
      boostersInActivity: 0,
      notStarted: 0,
      started: 0,
      finished: 0,
      chartId: 'pie-chart',
      datasetIdKey: 'label',
      options: {
        labels: [i18n.t('activityStatisticsNotStartedLabel'), i18n.t('activityStatisticsStartedLabel'), i18n.t('activityStatisticsFinishedLabel')],
        colors: ['#82B1FF', '#FBC02D', '#00C853'],
        dataLabels: {
          // style: {
          //   colors: ['#7c8386'],
          // },
          dropShadow: {
            enabled: false,
          },
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'left',
          formatter: (label) => {
            //return [opts.w.globals.seriesPercent[opts.seriesIndex] + "%", label];
            return ["%", label];
          },
          labels: {
            colors: ['#FFFFFF', '#FFFFFF', '#FFFFFF'],
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: "50%"
            }
          }
        }
      },
      series: [0, 0, 0],
      emptyOptions: {
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: "50%", // Adjust the size of the donut hole here
              labels: {
                show: false, // Hide labels
              },
            },
          },
        },
        selection: {
          enabled: false
        },
        labels: [i18n.t('activityStatisticsNotStartedLabel'), i18n.t('activityStatisticsStartedLabel'), i18n.t('activityStatisticsFinishedLabel')],
        colors: ['#82B1FF', '#FBC02D', '#00C853'],
        legend: {
          position: 'bottom',
          horizontalAlign: 'left',
          formatter: (label) => {
            //return [opts.w.globals.seriesPercent[opts.seriesIndex] + "%", label];
            return ["%", label];
          },
          labels: {
            colors: ['#FFFFFF', '#FFFFFF', '#FFFFFF'],
          },
          onItemClick: {
            toggleDataSeries: false
          },
          onItemHover: {
            highlightDataSeries: false
          },
        },
        dataLabels: {
          formatter: () => {
            return ['0%'];
          },
        },
        tooltip: {
          enabled: false
        },
      },
      emptySeries: [100], // Set the data to 100% (empty)
    }
  },
  async created() {
    this.loadingData = true
    await this.fetchPeopleInActivity();
    await this.fetchOwnersInActivity();
    await this.calculateStatistics();
    this.emptySeries = [100]
    this.loadingData = false
  },
  methods: {
    async calculateStatistics() {
      try {
          const response = await getActivityPagesTotalStats(this.activityId);
          if (response.status == 200) {
            this.notStarted = response.data.meta.statistics.not_started ? response.data.meta.statistics.not_started : 0
            this.started = response.data.meta.statistics.started ? response.data.meta.statistics.started : 0
            this.finished = response.data.meta.statistics.completed ? response.data.meta.statistics.completed : 0
            this.series = [this.notStarted, this.started, this.finished];
          }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    async fetchPeopleInActivity() {
      try {
        const response = await getPeopleInActivity(this.activityId, this.pageNumber)
        if (response.status == 200) {
          this.peopleInActivity = response.data.meta.total;
        }

      } catch (e) {
        if (e.response) {
          this.alertValue = true
          if (e.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          } else if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          } else {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },
    async fetchOwnersInActivity() {
      try {
        const response = await getBoostersInActivity(this.activityId, this.pageNumber, this.size)
        if (response.status == 200) {
          this.boostersInActivity = response.data.meta.total;
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true
          if (e.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          } else if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          } else {
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    }
  },
}
</script>
<style>
.apexcharts-legend-series {
  display: block !important;
  width: 100% !important;
  text-align: left !important;
}
/* .apexcharts-tooltip {
  color: #7c8386 !important;
} */
</style>
